import instance from "../../api";
import { INotificationFilters } from "./Notifications.interface";

/**
 * NotificationsService
 *
 * All notification API calls.
 * Base: /api/notifications/
 */
export const NotificationsService = {
  /**
   * List notifications (paginated).
   * GET /api/notifications/
   */
  async getNotifications(filters: INotificationFilters = {}) {
    const params: Record<string, any> = { ...filters };
    Object.keys(params).forEach((k) => {
      if (params[k] === "" || params[k] === undefined || params[k] === null) {
        delete params[k];
      }
    });
    return instance.get("notifications/", { params }).then((r) => r.data);
  },

  /**
   * Get notification detail.
   * GET /api/notifications/:id/
   */
  async getNotification(id: string) {
    return instance.get(`notifications/${id}/`).then((r) => r.data);
  },

  /**
   * Mark a single notification as read.
   * POST /api/notifications/:id/read/
   */
  async markRead(id: string) {
    return instance.post(`notifications/${id}/read/`).then((r) => r.data);
  },

  /**
   * Mark all notifications as read.
   * POST /api/notifications/read-all/
   */
  async markAllRead() {
    return instance.post("notifications/read-all/").then((r) => r.data);
  },

  /**
   * Get unread count.
   * GET /api/notifications/unread-count/
   */
  async getUnreadCount() {
    return instance
      .get("notifications/unread-count/")
      .then((r) => r.data as { unread_count: number });
  },
};